module.exports = __webpack_public_path__ + "images/emoji/o.17028c13cdaf1bb41058.png";